import {getHiddenDimensions} from "./Util";

class SmartBreadcrumbs {
	constructor( smartBreadcrumbsEl ) {
		this.rootEl = smartBreadcrumbsEl;
		this.addEllipsis();

		// Breadcrumb items.
		this.itemEls = this.rootEl.querySelectorAll( '.breadcrumb_item' );
		if ( this.itemEls.length >= 3 ) {
			this.magicLogic();
			window.addEventListener( 'resize', () => { this.magicLogic(); } );
		}
	}

	addEllipsis() {
		const ellipsisLi = document.createElement( 'li' );
		ellipsisLi.className = 'breadcrumb_item en_hidden';
		ellipsisLi.innerHTML = '…';
		this.rootEl.querySelectorAll( '.breadcrumb_item' )[0].after( ellipsisLi );
	}

	magicLogic() {
		const itemEls = Array.from( this.itemEls );
		const homeItemEl = itemEls[0];
		const ellipsisItemEl = itemEls[1];

		let width = this.rootEl.clientWidth - homeItemEl.offsetWidth - getHiddenDimensions( ellipsisItemEl ).outerWidth;
		let trimCount = 0;

		const variableItemEls = itemEls.slice( 2 ).toReversed();
		variableItemEls.forEach( ( itemEl, index ) => {
			itemEl.classList.remove( 'en_hidden' );
			width -= itemEl.offsetWidth;

			if ( width < 0 && index !== 0 ) {
				trimCount++;
				itemEl.classList.add( 'en_hidden' );
			}
		} );

		ellipsisItemEl.classList.toggle( 'en_hidden', !trimCount );
	}
}

function initSmartBreadcrumbs( scopeEl = document ) {
	const smartBreadcrumbsEls = scopeEl.querySelectorAll( '.mdl_breadcrumb' );
	smartBreadcrumbsEls.forEach( ( smartBreadcrumbsEl ) => {
		smartBreadcrumbsEl.SL_Smart_Breadcrumb ??= new SmartBreadcrumbs( smartBreadcrumbsEl );
	} );
}

export {
	SmartBreadcrumbs as default,
	initSmartBreadcrumbs
}
